<example-shell
  exampleId="multi-selection" [title]="title" [summary]="summary" [dataSnippet]="dataSnippet" [events]="events" (clear)="clearEvents()">
  <stackline-data-table
    title="Multi selection"
    [columns]="orderColumns"
    [data]="orders"
    [selectableRows]="true"
    [selectableRowsHighlight]="true"
    [highlightOnHover]="true"
    (selectedRowsChange)="record('multi selection', $event)">
  </stackline-data-table>
</example-shell>
